<div class="support-dashboard-detail-container" *ngIf="!activeTicket">
  <div class="card support-dashboard-detail-card">
    <div class="card-header support-dashboard-detail-header">
      <div class="flex-start support-dashboard-detail-title">
        <button
          class="btn btn-light support-dashboard-back-button"
          [routerLink]="backRoute"
          [queryParams]="backQueryParams"
        >
          <i class="fas fa-angle-left"></i>
          Back
        </button>
        <h5>{{ metricTitle }}</h5>
      </div>
    </div>

    <div class="card-body">
      <div class="support_filter support-dashboard-filter-row">
        <div class="support_select support-dashboard-filter-card">
          <div class="support_header">Tickets Between</div>
          <div class="support_types_container">
            <div>
              <input
                autocomplete="off"
                class="datetimepicker"
                type="text"
                [(ngModel)]="dateRange"
              />
            </div>
          </div>
        </div>

        <app-support-dashboard-reporter-filter
          *ngIf="showReporterFilter"
          [reporterOptions]="reporterOptions"
          [loadingReporters]="loadingReporters"
          [(selectedReporter)]="selectedReporter"
          (reporterChange)="onReporterChange($event)"
        ></app-support-dashboard-reporter-filter>

        <div
          class="support_select support-dashboard-filter-card support-dashboard-count-card"
        >
          <div class="support_header">Tickets</div>
          <div class="support_types_container">
            <div class="support-dashboard-ticket-count">
              {{ displayedTickets }} / {{ totalTickets }}
            </div>
          </div>
        </div>
      </div>

      <div class="error-message flex-start" *ngIf="errorMessage">
        <i class="fa fa-info-circle"></i>
        {{ errorMessage }}
      </div>

      <div class="support-dashboard-table-shell">
        <div class="support-dashboard-table-overlay" *ngIf="loadingTickets && hasTickets">
          <img
            src="../assets/img/loading_2.svg"
            alt="loading tickets"
            class="support-dashboard-loader-icon"
          />
          <span>Loading tickets...</span>
        </div>

        <div class="overflow_auto">
          <table
            class="table table-docs table-hover mt-20"
            id="support-dashboard-ticket-table"
          >
            <thead>
              <tr>
                <th>S.N.</th>
                <th *ngFor="let header of tableHeaders">
                  {{ header.name }}
                </th>
                <th *ngIf="showMarkAsMetAction">Action</th>
                <th *ngIf="showMarkAsBreachedAction">Action</th>
              </tr>
            </thead>
            <tbody *ngIf="loadingTickets && !hasTickets">
              <tr>
                <td [attr.colspan]="tableColumnCount">
                  <div class="file_name_textalign support-dashboard-loading-row">
                    <img
                      src="../assets/img/loading_2.svg"
                      alt="loading tickets"
                      class="support-dashboard-loader-icon"
                    />
                    Loading tickets...
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="!loadingTickets && !hasTickets">
              <tr>
                <td [attr.colspan]="tableColumnCount">
                  <div class="file_name_textalign">No Tickets Found</div>
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="hasTickets">
              <tr *ngFor="let ticket of tickets; let index = index">
                <td>{{ getSerialNumber(index) }}</td>
                <td
                  *ngFor="let header of tableHeaders"
                  [class.support-dashboard-summary-cell]="header.id === 'ticket_summary'"
                >
                  <span
                    *ngIf="header.id === 'ticket_id'; else standardTicketValue"
                    class="btn"
                    (click)="showTicketDetails(ticket)"
                  >
                    {{ getTicketDisplayValue(ticket, header.id) }}
                  </span>
                  <ng-template #standardTicketValue>
                    {{ getTicketDisplayValue(ticket, header.id) }}
                  </ng-template>
                </td>
                <td *ngIf="showMarkAsMetAction" class="support-dashboard-action-cell">
                  <button
                    type="button"
                    class="support-dashboard-action-button"
                    (click)="markAsMet(ticket)"
                    [disabled]="updatingTicketId !== null"
                  >
                    {{
                      updatingTicketId === ticket.ticket_id
                        ? "Updating..."
                        : "Mark as Met"
                    }}
                  </button>
                </td>
                <td *ngIf="showMarkAsBreachedAction" class="support-dashboard-action-cell">
                  <button
                    *ngIf="canShowMarkAsBreached(ticket); else noBreachedAction"
                    type="button"
                    class="support-dashboard-action-button"
                    (click)="markAsBreached(ticket)"
                    [disabled]="updatingTicketId !== null"
                  >
                    {{
                      updatingTicketId === ticket.ticket_id
                        ? "Updating..."
                        : "Mark as Breached"
                    }}
                  </button>
                  <ng-template #noBreachedAction>-</ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="paginator">
        <div class="flex-start support-dashboard-per-page">
          <span class="no-wrap">Per Page</span>
          <select
            class="form-select"
            [(ngModel)]="perPage"
            (change)="onPerPageChange()"
            [disabled]="loadingTickets"
          >
            <option
              *ngFor="let pageSize of perPageOptions"
              [ngValue]="pageSize"
            >
              {{ pageSize }}
            </option>
          </select>
        </div>

        <div class="support-dashboard-pagination-controls">
          <button
            type="button"
            class="support-dashboard-pagination-button support-dashboard-pagination-arrow"
            (click)="goToPreviousPage()"
            [disabled]="!canGoPrevious"
          >
            &laquo;
          </button>
          <button
            type="button"
            class="support-dashboard-pagination-button"
            (click)="goToPreviousPage()"
            [disabled]="!canGoPrevious"
          >
            Prev
          </button>
          <button
            type="button"
            class="support-dashboard-pagination-button support-dashboard-pagination-current"
            disabled
          >
            {{ currentPage }}
          </button>
          <button
            type="button"
            class="support-dashboard-pagination-button"
            (click)="goToNextPage()"
            [disabled]="!canGoNext"
          >
            Next
          </button>
          <button
            type="button"
            class="support-dashboard-pagination-button support-dashboard-pagination-arrow"
            (click)="goToNextPage()"
            [disabled]="!canGoNext"
          >
            &raquo;
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-support-dashboard-ticket-detail
  *ngIf="activeTicket"
  [ticket]="activeTicket"
  (back)="goBackToTicketList()"
></app-support-dashboard-ticket-detail>

<div
  class="support-dashboard-confirm-backdrop"
  *ngIf="confirmationTicket"
>
  <div class="support-dashboard-confirm-dialog">
    <div class="support-dashboard-confirm-header">
      <h5>Confirm Action</h5>
    </div>
    <div class="support-dashboard-confirm-body">
      Are you sure you want to mark this Ticket as met?
    </div>
    <div class="support-dashboard-confirm-footer">
      <button
        type="button"
        class="btn btn-light"
        (click)="closeMarkAsMetConfirmation()"
        [disabled]="updatingTicketId !== null"
      >
        No
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="confirmMarkAsMet()"
        [disabled]="updatingTicketId !== null"
      >
        Yes
      </button>
    </div>
  </div>
</div>

<div
  class="support-dashboard-confirm-backdrop"
  *ngIf="exceptionFormTicket"
>
  <div class="support-dashboard-confirm-dialog support-dashboard-exception-dialog">
    <div class="support-dashboard-confirm-header">
      <h5>Mark as Met</h5>
    </div>
    <div class="support-dashboard-confirm-body">
      <div class="support-dashboard-exception-note">
        Update SLA exception for ticket
        <strong>{{ exceptionFormTicket.ticket_id }}</strong>
      </div>

      <div class="support-dashboard-form-row">
        <label class="support-dashboard-form-label">Status</label>
        <input
          type="text"
          class="form-control"
          [value]="exceptionStatus"
          readonly
        />
      </div>

      <div class="support-dashboard-form-row">
        <label class="support-dashboard-form-label">Reason</label>
        <textarea
          class="form-control support-dashboard-reason-field"
          [(ngModel)]="exceptionReason"
          (ngModelChange)="exceptionReasonError = null"
          rows="4"
          placeholder="Enter reason"
          [disabled]="updatingTicketId !== null"
        ></textarea>
        <div
          class="support-dashboard-form-error"
          *ngIf="exceptionReasonError"
        >
          {{ exceptionReasonError }}
        </div>
      </div>
    </div>
    <div class="support-dashboard-confirm-footer">
      <button
        type="button"
        class="btn btn-light"
        (click)="closeExceptionForm()"
        [disabled]="updatingTicketId !== null"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="submitExceptionForm()"
        [disabled]="updatingTicketId !== null"
      >
        {{
          updatingTicketId === exceptionFormTicket.ticket_id
            ? "Updating..."
            : "Submit"
        }}
      </button>
    </div>
  </div>
</div>

<div
  class="support-dashboard-confirm-backdrop"
  *ngIf="breachedConfirmationTicket"
>
  <div class="support-dashboard-confirm-dialog">
    <div class="support-dashboard-confirm-header">
      <h5>Confirm Action</h5>
    </div>
    <div class="support-dashboard-confirm-body">
      Are you sure you want to mark this Ticket as breached?
    </div>
    <div class="support-dashboard-confirm-footer">
      <button
        type="button"
        class="btn btn-light"
        (click)="closeMarkAsBreachedConfirmation()"
        [disabled]="updatingTicketId !== null"
      >
        No
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="confirmMarkAsBreached()"
        [disabled]="updatingTicketId !== null"
      >
        Yes
      </button>
    </div>
  </div>
</div>

<div
  class="support-dashboard-confirm-backdrop"
  *ngIf="breachedExceptionFormTicket"
>
  <div class="support-dashboard-confirm-dialog support-dashboard-exception-dialog">
    <div class="support-dashboard-confirm-header">
      <h5>Mark as Breached</h5>
    </div>
    <div class="support-dashboard-confirm-body">
      <div class="support-dashboard-exception-note">
        Update SLA exception for ticket
        <strong>{{ breachedExceptionFormTicket.ticket_id }}</strong>
      </div>

      <div class="support-dashboard-form-row">
        <label class="support-dashboard-form-label">Status</label>
        <input
          type="text"
          class="form-control"
          value="breached"
          readonly
        />
      </div>

      <div class="support-dashboard-form-row">
        <label class="support-dashboard-form-label">Reason</label>
        <textarea
          class="form-control support-dashboard-reason-field"
          [(ngModel)]="breachedReason"
          (ngModelChange)="breachedReasonError = null"
          rows="4"
          placeholder="Enter reason"
          [disabled]="updatingTicketId !== null"
        ></textarea>
        <div
          class="support-dashboard-form-error"
          *ngIf="breachedReasonError"
        >
          {{ breachedReasonError }}
        </div>
      </div>
    </div>
    <div class="support-dashboard-confirm-footer">
      <button
        type="button"
        class="btn btn-light"
        (click)="closeBreachedExceptionForm()"
        [disabled]="updatingTicketId !== null"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="submitBreachedExceptionForm()"
        [disabled]="updatingTicketId !== null"
      >
        {{
          updatingTicketId === breachedExceptionFormTicket.ticket_id
            ? "Updating..."
            : "Submit"
        }}
      </button>
    </div>
  </div>
</div>
